const CuratorRow = ({ label, value, testId }) => (
  <div className="rounded-[18px] border border-[#D4AF37]/18 bg-white px-4 py-3" data-testid={testId}>
    <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#8b6d16]">{label}</p>
    <p className="mt-2 text-sm leading-7 text-[#001935]">{value}</p>
  </div>
);

export const AdvisorShortlistCuratorCard = ({ curator }) => {
  if (!curator) return null;

  return (
    <div className="rounded-[22px] border border-[#D4AF37]/25 bg-[#fff7e5] px-4 py-4 shadow-[0_10px_26px_rgba(0,25,53,0.06)]" data-testid="signature-advisor-shortlist-curator-card">
      <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#8b6d16]" data-testid="signature-advisor-shortlist-curator-eyebrow">AI shortlist curator</p>
      <h4 className="mt-2 text-lg font-semibold text-[#001935]" data-testid="signature-advisor-shortlist-curator-title">{curator.title}</h4>
      <p className="mt-2 text-sm leading-7 text-[#5f5a4e]" data-testid="signature-advisor-shortlist-curator-summary">{curator.summary}</p>

      <div className="mt-4 grid gap-3" data-testid="signature-advisor-shortlist-curator-grid">
        <CuratorRow label="Primary pick" testId="signature-advisor-shortlist-curator-primary" value={curator.primary_pick} />
        <CuratorRow label="Backup pick" testId="signature-advisor-shortlist-curator-backup" value={curator.backup_pick} />
        <CuratorRow label="Watchout" testId="signature-advisor-shortlist-curator-watchout" value={curator.watchout} />
        <CuratorRow label="Next step" testId="signature-advisor-shortlist-curator-next-step" value={curator.next_step} />
      </div>
    </div>
  );
};